import { render, staticRenderFns } from "./SuspiciousGroupJoinInvestigator.vue?vue&type=template&id=5e9a48aa&scoped=true&"
import script from "./SuspiciousGroupJoinInvestigator.vue?vue&type=script&lang=js&"
export * from "./SuspiciousGroupJoinInvestigator.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousGroupJoinInvestigator.vue?vue&type=style&index=0&id=5e9a48aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a48aa",
  null
  
)

export default component.exports